/** 생성·수정 요청이 5xx·네트워크 실패일 때 다시 보내는 최대 횟수. */
export const WRITE_REQUEST_MAX_RETRIES = 3;

const HTTP_CONFLICT = 409;

/**
 * 요청 오류의 HTTP 상태 코드. Amplify 게이트웨이 오류는 `response.status ?? response.statusCode` 에,
 * 그 밖의 오류는 `status` 에 싣는다. 시계열 생성 오류처럼 상태가 메시지에만 실려 오는 경우는 중복(409)만 읽는다.
 */
export const responseStatusOf = (error: unknown): number | undefined => {
  const failure = error as {
    response?: { status?: unknown; statusCode?: unknown };
    status?: unknown;
    message?: unknown;
  } | null;
  const status =
    failure?.response?.status ?? failure?.response?.statusCode ?? failure?.status;
  if (typeof status === "number") return status;
  if (typeof failure?.message === "string" && failure.message.includes(String(HTTP_CONFLICT))) {
    return HTTP_CONFLICT;
  }
  return undefined;
};

export const isDuplicateFailure = (error: unknown) =>
  responseStatusOf(error) === HTTP_CONFLICT;

/**
 * 생성·수정 요청 재시도 판정 — 4xx 는 다시 보내도 같은 답이라 바로 실패로 끝낸다.
 * 중복(409) 오류를 세 번 재시도하면 사용자는 스피너를 3초 넘게 본 뒤에야 겹침 오류를 본다.
 */
export const shouldRetryWriteRequest = (failureCount: number, error: unknown) => {
  const status = responseStatusOf(error);
  const isClientError = status !== undefined && status >= 400 && status < 500;
  if (isClientError) return false;
  return failureCount < WRITE_REQUEST_MAX_RETRIES;
};
